import { LOG_OUT } from "../login/action";
import { SET_PROFILE_REQUIRED_FIELD } from "./action";

export const defaultState = {
  ProfileRequiredFields : [],
};

function ProfileRequiredFields(state = defaultState, action) {
  switch (action.type) {
    case SET_PROFILE_REQUIRED_FIELD:
      return {
        ...state,
        ProfileRequiredFields: action.payload,
      };
    case LOG_OUT:
      return defaultState;
    default:
      return state;
  }
}

export default ProfileRequiredFields;
